/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Dull_Mammoth_ForgiveInputs */

const fr_game_dull_mammoth_forgive = /** @type {(inputs: Game_Dull_Mammoth_ForgiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuel`)
};

/**

* @param {Game_Dull_Mammoth_ForgiveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const game_dull_mammoth_forgive = /** @type {((inputs?: Game_Dull_Mammoth_ForgiveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Dull_Mammoth_ForgiveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_game_dull_mammoth_forgive(inputs)
});